
app.service("TrackingService", ['$rootScope', 'SiteHelper', function ($rootScope, SiteHelper) {


    const service = this;
    const siteHelper = SiteHelper;
    const trackingDisabled = false;

    const trackEvent = (trackingType, trackingName, params) => {
        if(typeof gtag === 'undefined' || trackingDisabled ){
            return;
        }
        gtag(trackingType, trackingName, params);
    }

    this.track_sale = function (order, withParams) {
        withParams = withParams ? withParams : {};
        const items = [];
        const lines = withParams.lines ?? (order.lines ?? []);
        for(let line of lines){
            let listName = withParams.list_name ?? null;
            if(!listName){
                if(line.transferred_from_staff){
                    listName = "Staff Transfer";
                } else {
                    const browseID = line.state_ids?.browse_id ?? null;
                    if(browseID === "solution"){
                        listName = "Complete Solution";
                    } else if(browseID === "site_range"){
                        listName = "Range";
                    } else {
                        const methodProductID = line.state_ids?.method_product_id ?? null;
                        if(methodProductID === "matrix"){
                            listName = "Cabinet Matrix";
                        } else {
                            listName = "Component";
                        }
                    }
                }
            }
            const range = line.range && line.range !== "_default" ? siteHelper.uppercaseFirstWords(line.range.split("_").join(" ")) : "";
            const colour = line.colour && line.colour !== "_default" ? siteHelper.uppercaseFirstWords(line.colour.split("_").join(" ")) : "";
            const style = line.style && line.style !== "_default" ? siteHelper.uppercaseFirstWords(line.style.split("_").join(" ")) : "";
            const brand = range === "Pronto" && style ? style : (range === style ? range : (range + (range && style ? " " : "") + style));
            items.push({
                id: line._product_code ?? (line.product_code ?? (line.unit ?? "unknown")),
                name: line._description ?? (line.description ?? "unknown"),
                list_name: listName,
                brand: brand,
                category: line.group_name ?? "unknown",
                variant: colour,
                list_position: 1,
                quantity: line.quantity ?? 1,
                price: line.cost ?? 0,
            })
        }

        const params = {
            transaction_id: order._id ?? "unknown",
            affiliation: "MyBA",
            value: order._total_price ?? 0,
            currency: order._currency ?? "GBP",
            shipping: order._carriage_price ?? 0,
            tax: order._vat_price ?? 0,
            items: items,
        }
        trackEvent('event', 'purchase', params);
    }

    this.track_event = function (trackingName, eventCategory, params) {
        params = params ? params : {};
        params.event_category = eventCategory ? eventCategory : params.event_category;
        params.event_label = params.event_label ? params.event_label : window.location.href;
        params.transport_type = params.transport_type ? params.transport_type : 'beacon';
        trackEvent('event', trackingName, params);
    }

    const trackExternalLinksAndDownloads =  () =>
    {
        const outboundTrack = (url) => {


            trackEvent('event', 'Outbound Links',
                {
                    event_category: url,
                    event_label: window.location.href,
                    transport_type:'beacon',
                });

            setTimeout(function () {
                window.open(url, '_blank').focus();
            },100)
        };

        document.body.addEventListener('click',  (mouseEvent) => {

            let link = mouseEvent.target.closest("a[href^=http], a[href^=mailto], a[href^=tel]");
            let href = link ? link.href : null;
            let isFile = false;
            if(!href){
                link = mouseEvent.target.closest("a");
                href = link ? link.href : null;
                if(href){
                    const filetypes = /\.(zip|exe|dmg|pdf|doc.*|xls.*|ppt.*|mp3|txt|rar|wma|mov|avi|wmv|flv|wav)$/i;
                    if (href.match(filetypes))
                    {
                        isFile = true;
                    } else {
                        href = null;
                    }
                }
            }
            if(!href){
                return
            }

            if(!href.includes('mailto:')  && !href.includes('tel:') && !isFile  )
            {
                event.preventDefault();
                outboundTrack(href);
            } else {
                if (isFile)
                {
                    const extension = (/[.]/.exec(href)) ? /[^.]+$/.exec(href) : undefined;
                    if (extension)
                    {

                        const title = link.dataset.title ?? "";
                        const params = {
                            event_category: title ? title : href,
                            event_label: window.location.href,
                            transport_type:'beacon',
                        }

                        trackEvent('event', 'Downloads '+extension, params);
                    }
                }

                if (href.match(/^mailto:/i))
                {
                    const label = href.replace(/^mailto:/i, '');

                    trackEvent('event', 'Email',
                        {
                            event_category: label,
                            event_label: window.location.href,
                            transport_type:'beacon',
                        });
                }

                if (href.match(/^tel:/i))
                {
                    const label = href.replace(/^tel:/i, '');
                    trackEvent('event', 'Telephone',
                        {
                            event_category: label,
                            event_label: window.location.href,
                            transport_type:'beacon',
                        });
                }
            }
        });
    };

    trackExternalLinksAndDownloads();
}]);